import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            资源分类导航
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            按类别浏览，快速找到你需要的Galgame资源
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 text-center transition-all duration-300 hover:border-primary-300/60 hover:bg-primary-50/30 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 md:mb-4 flex items-center justify-center rounded-full bg-primary-100/80 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-400 mb-3 line-clamp-2">
                {cat.description}
              </p>
              <span className="text-xs text-primary-500 font-medium">
                {cat.count.toLocaleString()} 款资源
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}